import React from 'react';

import { Skeleton } from '@/components/memo';

import './NotificationPlaceholder.css';

const NotificationPlaceholder: React.FC = () => {
  return (
    <div className="notification-item">
      <div className="notification-item__information">
        <Skeleton className="notification-placeholder__category-skeleton" />
        <Skeleton className="notification-placeholder__timestamp-skeleton" />
      </div>
      <div>
        <div className="notification-item__title-container">
          <Skeleton className="notification-placeholder__unread-badge-skeleton" />
          <Skeleton className="notification-placeholder__title-skeleton" />
        </div>
        <Skeleton className="notification-placeholder__message-skeleton" />
      </div>
      <div className="notification-item__action">
        <Skeleton className="notification-placeholder__action-text-skeleton" />
        <Skeleton className="notification-placeholder__action-icon-skeleton" />
      </div>
    </div>
  );
};

export default NotificationPlaceholder;
